import * as PropTypes from 'prop-types';
import * as React from 'react';
import { APIRequest, UserStore } from '@reverbdotcom/discovery-ui';
import Upsell from '@reverbdotcom/discovery-ui/dist/product_show_page/upsell';
import UrlHelpers from '../shared/url_helpers';
import AddToCartButton from '../listings/cart/add_to_cart_button';

const UPSELLS_MAX = 4;

class CartUpsells extends React.Component {
  constructor() {
    super();

    this.state = {
      upsells: [],
    };
  }

  componentDidMount() {
    this.fetchUpsells();
  }

  fetchUpsells() {
    if (this.upsellsDisabled()) { return; }

    APIRequest.V3.get(
      UrlHelpers.upsellsPath(),
      {
        include_grid_images: true,
        id: this.props.listingIds,
      },
    ).then((response) => {
      const upsells = (response.upsells || []).slice(0, UPSELLS_MAX);

      this.setState({
        upsells,
      });
    });
  }


  get hasUpsells() {
    return this.state.upsells.length;
  }

  upsellsDisabled() {
    return UserStore.getState().countryCode !== 'US';
  }

  renderUpsell(upsell, index) {
    return (
      <Upsell
        upsell={upsell}
        index={index}
        addToCartButton={AddToCartButton}
      />
    );
  }

  render() {
    if (this.upsellsDisabled()) { return null; }
    if (!this.hasUpsells) { return null; }

    return (
      <div className={this.props.className}>
        {this.props.children}
        <h4 className="weight-bold">
          {I18n.t('productShowPage.recommends')}
        </h4>
        <ul className="g-container g-container--cycle scaling-mtb-2">
          {this.state.upsells.map((upsell, i) => (
            <li
              className="g-col-3 g-col-mobile-6"
              key={upsell.id}
            >
              {this.renderUpsell(upsell, i)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

CartUpsells.propTypes = {
  listingIds: PropTypes.array,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default CartUpsells;



// WEBPACK FOOTER //
// ./src/components/cart/cart_upsells.jsx